module.exports = __webpack_public_path__ + "assets/img/model1.d4df525b.png";